import { render } from "./Dropdown.vue?vue&type=template&id=55954f07"
import script from "./Dropdown.vue?vue&type=script&lang=ts"
export * from "./Dropdown.vue?vue&type=script&lang=ts"
script.render = render

export default script